"use client";

import { ArrowUpRight, Brain, Lock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const labs = [{
  id: "SOL-01",
  name: "Solar Chromosphere",
  description: "High-frame-rate Hα imaging of the solar chromosphere — active regions, filaments, prominences and spicules.",
  tags: ["#H-ALPHA", "#PROMINENCES", "#SUNSPOTS"],
  accentVar: "--chart-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697763/img/solar_first_light.webp",
  srcset: "https://solobservatory.com/wp-content/uploads/2026/06/andromeda-scaled.jpg?v=8un0qubiy7q-wvc-srcset",
  sizes: "https://solobservatory.com/wp-content/uploads/2026/06/andromeda-scaled.jpg?v=tzil9wf0itb-wvc-sizes",
  icon: Brain,
  ctaText: "VIEW OBSERVATIONS",
  ctaRoute: "/SolarChromospherePage"
}, {
  id: "DSK-02",
  name: "Deep-Sky & Cosmos",
  description: "Narrowband and broadband imaging of nebulae, galaxies and star clusters from Bortle 5 skies in Vernon, BC.",
  tags: ["#NEBULAE", "#TESS", "#NARROWBAND"],
  accentVar: "--chart-2",
  image: "https://solobservatory.com/wp-content/uploads/2026/06/andromeda-scaled.jpg?v=lohlxvbxmb",
  srcset: "https://solobservatory.com/wp-content/uploads/2026/06/andromeda-scaled.jpg?v=qvub90n024-wvc-srcset",
  sizes: "https://solobservatory.com/wp-content/uploads/2026/06/andromeda-scaled.jpg?v=wyrj9oxse5f-wvc-sizes",
  icon: Lock,
  ctaText: "VIEW OBSERVATIONS",
  ctaRoute: "/DeepSkyCosmosPage"
}];
export default function DualCoreExploration() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return;
}